<template>

    <div>
        <template v-if="method === 'trustly'">
            <div class="orange-payment-method-expanded">

                <!-- Swish: Step 1 -->
                <div>
                    <span class="text-sm text-gray-400 mb-1 block">Anslut till din bank med Mobilt Bank ID och gör en överföring</span>
                </div>

                <div class="text-center mt-8 mb-2">
                    <card-button @click="pay" :loading="loading">Välj bank</card-button>
                </div>

            </div>
        </template>
    </div>

</template>

<script>
    import axios from 'axios'
    import CardButton from "./CardButton"

    export default {
        components: {CardButton},
        props: ['api', 'name', 'orderId', 'method', 'successUrl'],
        data() {
            return {
                loading: false,
            }
        },
        watch: {
        },
        methods: {
            async pay() {
                this.loading = true
                let successUrl = this.successUrl

                let props = this.$router.resolve({
                    name: 'success',
                    params: { accountId: 1, id: this.orderId },
                })

                if (! successUrl) {
                    successUrl = document.location.origin + document.location.pathname + props.href
                }

                let response = await axios.post(`${this.api}/trustly/init`, {
                    order_id: this.orderId,
                    success_url: successUrl
                })

                window.top.location = response.data.deposit.url
            },
        }
    }
</script>

<style type="text/css">
    .orange-payment-method-expanded {
        padding-top: 22px;
        padding-left: 28px;
        padding-right: 28px;
    }
</style>